<template>
  <v-container
    class="mt-3 mx-auto"
  >
    <v-row>
      <v-col cols="1">
        <v-container>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                fab
                v-bind="attrs"
                v-on="on"
                @click="$router.back()"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </template>
            <span>Previous Page</span>
          </v-tooltip>
        </v-container>
      </v-col>
      <v-col cols="1">
        <excel-import></excel-import>
      </v-col>
    </v-row>
    <v-toolbar
      class="mt-4"
      color="primary"
      dark
    >
      <v-autocomplete
        v-model="supplier"
        item-value="id"
        :items="suppliers"
        :search-input.sync="searchInput"
        no-filter
        style="max-width: 300px"
        class="mt-5"
        placeholder="Search Supplier here..."
      >
        <template v-slot:selection="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:item="{ item }">
          <span class="blue--text">{{ item.id }}</span>
          <span class="mx-1"></span>
          <small class="gray--text">{{ item.name }}</small>
        </template>
      </v-autocomplete>
      <v-spacer></v-spacer>
      <v-card-title class="my-2">Supplier Products</v-card-title>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col
          cols="6"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              <v-card-title>Add Product</v-card-title>
            </v-toolbar>
            <create-supplier-product
              :propSupplierProducts="supplierProducts"
              :propSupplierId="supplier"
            />
          </v-card>
        </v-col>
        <v-col
          cols="6"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              <v-card-title>Edit Product</v-card-title>
            </v-toolbar>
            <edit-supplier-product
              ref="edit-supplier-product"
            />
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card class="ma-0">
            <v-toolbar
              color="primary"
              dark
            >
              <v-card-title>Products</v-card-title>
            </v-toolbar>
            <index-supplier-product
              @list-update="splrPdListUpdate"
              :propSupplierId="supplier"
              @edit-supplier-product="editSupplierProduct"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  let typingSupplier = null
  export default {
    name: 'vSupplierProducts',
    components: {
      createSupplierProduct: () => import('./../components/supplier-product/Create'),
      editSupplierProduct: () => import('./../components/supplier-product/Edit'),
      indexSupplierProduct: () => import('./../components/supplier-product/Index'),
      excelImport: () => import('@/views/dashboard/components/supplier-product/Import'),
    },
    data () {
      return {
        supplier: null,
        supplierProducts: [],
        searchInput: null,
      }
    },
    mounted () {
      this.searchSupplier()
      this.supplier = this.$route.params.supplier
      // this.searchInput = this.$route.params.supplier
    },
    computed: {
      ...mapState({
        supplierUpdated: state => state.supplier.channelUpdate,
        suppliers: state => state.supplier.list,
      }),
    },
    watch: {
      searchInput (val, old) {
        clearTimeout(typingSupplier)
        typingSupplier = setTimeout(() => {
          if (!val) val = old
          this.searchSupplier(val)
        }, 500)
      },
    },
    methods: {
      ...mapActions({
        fetchSuppliers: 'supplier/fetch',
      }),
      editSupplierProduct (data) {
        const { populateVars } = this.$refs['edit-supplier-product']
        populateVars(data)
      },
      splrPdListUpdate (data) {
        this.supplierProducts = data
      },
      searchSupplier (val = '') {
        this.fetchSuppliers({
          index: 0,
          count: 10,
          search: val,
        })
      },
    },
  }
</script>
